"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRAND_BENEFIT_LIMITS = void 0;
exports.BRAND_BENEFIT_LIMITS = {
    MAX_ADD_TO_CART_BUTTON_BENEFITS: 3,
    MAX_BUY_NOW_BUTTON_BENEFITS: 3,
    MAX_CHECKOUT_BUTTON_BENEFITS: 3,
    MAX_DESCRIPTION_LENGTH: 90,
};
